module.exports = __webpack_public_path__ + "static/media/new_logo_darwined.77e917e9.svg";